import styled from 'styled-components'
import { Spacings, Text, COLORS } from '@styles'

/*
 * The Documents tab reuses the card chrome built for the Basic Details tab so
 * every InvoiceDetails tab stays visually identical. Shared primitives are
 * re-exported from the sibling style module; only the document-specific pieces
 * (status label, file tiles, empty state, export rows) are defined here.
 */
export { BasicDetailsCard, CardHeader, CardTitle, HeaderRight, ChevronBtn, SectionDivider } from '../BasicDetails/style'

export const CardsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

export const CardTitleRow = styled.div`
	display: flex;
	align-items: baseline;
	gap: ${Spacings.SPACING_6};
`

export const StatusLabel = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_500};
	color: ${({ $hasDocs, theme }) => ($hasDocs ? COLORS.blue.default : theme.palette.text.greydark)};
`

/* ---- Uploaded file tiles ---- */

export const DocTilesRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${Spacings.SPACING_4B};
`

export const DocTile = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	padding: ${Spacings.SPACING_3B};
	background: ${({ theme }) => theme.palette.background.blue};
	border-radius: ${Spacings.SPACING_2B};

	& svg {
		color: ${({ theme }) => theme.palette.text.white};
	}
`

export const Note = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_400};
	color: ${({ theme }) => theme.palette.text.greydark};
`

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${Spacings.SPACING_2};
	padding: ${Spacings.SPACING_4B} 0;
	text-align: center;
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_400};
	color: ${({ theme }) => theme.palette.text.greydark};
`

/* ---- Export Documents card ---- */

export const ExportControls = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_6};
`

export const ExportSelectWrapper = styled.div`
	width: 14rem;
`

export const ExportList = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

export const ExportRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
	border: 1px solid ${({ theme }) => theme.palette.background.greyBorder};
	border-radius: ${Spacings.SPACING_5};
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
`

export const ExportName = styled.span`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.palette.text.blackGrey};
`

export const ExportIconTile = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${Spacings.SPACING_3B};
	background: ${({ theme }) => theme.palette.background.blue};
	border-radius: ${Spacings.SPACING_2B};
	flex-shrink: 0;

	& svg {
		color: ${({ theme }) => theme.palette.text.white};
	}
`
